import React, { useEffect } from "react";

import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import ImageAside from "../../components/image-aside/Image-aside";
import "./Lending.css";
import { lendingImage, tinyLendingImage } from "../../assets";
import { useNavigate } from "react-router-dom";

const textContents = {
  title: "Empowering Businesses Through Private Equity Funding",
  paragraph:
    "At One Life Equity Fund, we pride ourselves on our ability to provide commercial private equity funding that has a significant impact on businesses. With our expertise and financial support, we help businesses grow, expand, and achieve their goals.",
  callToAction: "Start Application",
};
export default function Lending() {
  const navigate = useNavigate();  

  
  return (
    <div>
      <PageNameBanner pageName="Lending" />
      <div className="lending">
        <ImageAside
          mainText={textContents.title}
          mainParagraph={textContents.paragraph}
          imageSrc={lendingImage}
          tinyImageSrc={tinyLendingImage}
          buttonText={textContents.callToAction}
          buttonEventHandler={()=> navigate('/loan-application-form')}
        >
          <h2>Types of Loans</h2>
          <ul>
            <li>Term Loans</li>
            <li>Mezzanine Loans</li>
            <li>Bridge Loans</li>
            <li>Construction Loans</li>
            <li>Renovation Loans</li>
            <li>Soft Secured Loans</li>
          </ul>
        </ImageAside>
      </div>
    </div>
  );
}
